<app-callcard-list-title [callcard]="callcard" [style.color]="color"></app-callcard-list-title>
<app-callcard-list-event *ngIf="callcard.event" [event]="callcard.event"></app-callcard-list-event>
<app-callcard-list-location *ngIf="callcard.location" [location]="callcard.location"></app-callcard-list-location>
